import React, { useState, useEffect } from 'react';
import Confetti from 'react-confetti'
import { notification } from 'antd';
import ELEMENTALS_DATA from './elementals.json';
import './App.scss';

const AZUKI = "Azuki";
const ELEMENTAL = "Elemental";

const getRandomAzuki = () => {
  const tokenId = Math.floor(Math.random() * 10000);
  return {
    collection: AZUKI,
    tokenId,
    image: `https://ipfs.io/ipfs/QmYDvPAXtiJg7s8JdRBSLWdgSphQdac8j1YuQNNxcGE1hg/${tokenId}.png`,
    openSeaURL: `https://opensea.io/assets/ethereum/0xed5af388653567af2f388e6224dc7c4b3241c544/${tokenId}`,
    name: `Azuki #${tokenId}`,
  };
};

const getRandomElemental = () => {
  const index = Math.floor(Math.random() * 8207);
  const elemental = ELEMENTALS_DATA["ELEMENTALS"][index];
  const tokenId = elemental.name.split("#")[1];

  return {
    collection: ELEMENTAL,
    tokenId,
    image: elemental.image,
    openSeaURL: `https://opensea.io/assets/ethereum/0xb6a37b5d14d502c3ab0ae6f3a0e058bc9517786e/${tokenId}`,
    name: elemental.name,
  };
};

const chooseCollection = () => {
  return Math.floor(Math.random() * 2) === 0 ? AZUKI : ELEMENTAL;
}

const chooseItem = () => {
  return chooseCollection() === AZUKI ? getRandomAzuki() : getRandomElemental();
} 

const App = () => {
  const [api, contextHolder] = notification.useNotification();

  const [score, setScore] = useState(0);
  const [item, setItem] = useState('');
  const [isGameOver, setIsGameOver] = useState(false);
  const [playConfetti, setPlayConfetti] = useState(false);
  const [confettiParams, setConfettiParams] = useState({});

  useEffect(() => {
    setItem(chooseItem);
  }, []);

  const handleGuess = guess => {
    const message = guess === item.collection
      ? <>Yup! That was <a href={item.openSeaURL} target="_blank" rel="noreferrer">{item.name}</a></>
      : <>Sorry! That was <a href={item.openSeaURL} target="_blank" rel="noreferrer">{item.name}</a></>
    api.open({
      message: <div style={{
        display:'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <img src={item.image} width={50} alt={item.name} style={{marginRight: '10px'}}/>
        <div>{message}</div>
      </div>,
      placement: 'top',
      duration: 2,
      key: "notification"
    });
    
    if (guess === item.collection) {
      setScore(score + 1);
      setItem(chooseItem());
    } else {
      if(score > 0) {
        const confettiParams = {};
        if(score === 1) {
          confettiParams.numberOfPieces = 50;
        } else if(score < 5) {
          confettiParams.numberOfPieces = 150;
        } else if(score < 10) {
          confettiParams.numberOfPieces = 500;
        } else {
          confettiParams.numberOfPieces = 2500;
        }

        setConfettiParams(confettiParams);
        setPlayConfetti(true);
      }
      setIsGameOver(true);
    }
  };

  const playAgain = () => {
    setScore(0);
    setIsGameOver(false);
    setItem(chooseItem());
  };

  const finishConfetti = () => {
    setPlayConfetti(false);
  }

  return (
    <div className="App">
      {contextHolder}
      {/*<h1>Azuki or Elemental</h1>*/}
      <div className="title">
        <img src="azuki-logo.png" alt="azuki-logo"/> or <img src="elemental-logo.png" alt="elemental-logo"/>
      </div>
      <h2>Can you tell them apart?</h2>
      <div className="game">
        {isGameOver &&
          <div>
            <p>Game over!</p>
            { score === 0 &&
              <>
                <p>You didn't get any right 😢</p>
                <p>That's okay, it's hard.</p>
              </>
            }
            { score === 1 &&
              <p>You got one right. You had about a 50/50 chance, so that's not bad!</p>
            }
            { score > 1 &&
              <p>You got {score} in a row! 🎉</p>
            }
            <button onClick={playAgain}>Play again</button>
          </div>
        }
        {!isGameOver && 
          <>
            <img className="token-image" src={item.image} alt="Random" width="300" height="300" />
            <div className="buttons">
              <button className="azuki" onClick={() => handleGuess(AZUKI)}>Azuki</button>
              <button className="elemental" onClick={() => handleGuess(ELEMENTAL)}>Elemental</button>
            </div>
            { score > 0 &&
              <div className="streak">Streak: {score}</div>
            }
          </>
        }
      </div>
      <div className="credits">
        <p className="center">Built by <a href="https://twitter.com/MikeSylphDapps" target="_blank" rel="noreferrer">mike.sylphdapps.eth</a>.</p>
        <p className="center">You can see my other work at <a href="https://sylphdapps.com" target="_blank" rel="noreferrer">Sylph Dapps</a>.</p>
        <p className="center">We kid, but we ❤️ you, Azuki.</p>
      </div>

      {playConfetti &&
        <Confetti
          onConfettiComplete={finishConfetti}
          recycle={false}
          gravity={0.5}
          {...confettiParams}
        />
      }
    </div>
  );
};

export default App;